<!--suppress AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/settings" translate>Settings</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/subscription-update" translate>Subscription Info</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Choose Package</li>
  </ol>
</nav>
<div [hidden]="loading" *ngIf="subscriptions" class="account-settings-container layout-top-spacing">
  <div class="account-content">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">

      <div class="row shadow-lg mx-auto my-auto p-3 bg-white rounded">
        <div class="col-6">
          <div class="input-group">
            <input type="text" class="form-control" name="couponCode" [(ngModel)]="couponCode" placeholder="{{'Coupon code' | translate}}" aria-label="Coupon code" aria-describedby="button-coupon">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" (click)="validateCoupon()" id="button-coupon" translate>Validate Coupon</button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="marketingSubscriptions">
        <div class="row" *ngFor="let subscription of marketingSubscriptions">
          <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
            <app-package-panel [myBusiness]="myBusiness" [isCurrentSubscription]="currentSubscription.id == subscription.id" (packageSelected)="submitPackage($event)" [isSelecting]="true" [lang]="lang" [paylinkSubscription]="subscription"></app-package-panel>
          </div>
        </div>
      </div>

      <div class="row" *ngFor="let subscription of subscriptions">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <app-package-panel [myBusiness]="myBusiness" [isCurrentSubscription]="currentSubscription.id == subscription.id" (packageSelected)="submitPackage($event)" [isSelecting]="true" [lang]="lang" [paylinkSubscription]="subscription"></app-package-panel>
        </div>
      </div>

    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
